import React from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { getGliddenBannerInfo, getBehrBannerInfo } from '../../utils/bannerUtils';
import './PromoBanners.scss';

// Desktop/Tablet image intrinsic size: 700 x 100 px
// Mobile image intrinsic size: 375 x 85 px
export const PromoBanners = () => {
  const behrInfo = getBehrBannerInfo(useConfigService);
  const gliddenInfo = getGliddenBannerInfo(useConfigService);

  return (
    <div className="promo-banners sui-justify-center sui-w-full">
      <a href={behrInfo.redirectLink} className="promo-banner">
        <img src={behrInfo.image} alt="promo1" title="promo1" />
      </a>
      <a href={gliddenInfo.redirectLink} className="promo-banner">
        <img src={gliddenInfo.image} alt="promo2" title="promo2" />
      </a>
    </div>
  );
};
